import type { PublicUser as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** Whoever scanned a ticket. Both fields are non-null on the wire, so nothing here can be absent. */
export type ScanUser = {
  name: string;
  email: string;
};

export const fromGql = (item: GQLItem): ScanUser => take<ScanUser>(item, 'name', 'email');
